<div class="container">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="search-form">
    <!-- Keyword -->
    <mat-form-field appearance="outline" style="width: 300px">
      <mat-label>
        {{ "view_value.search_addmintrator" | translate }}
      </mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        formControlName="keyword"
        [placeholder]="'view_value.search_addmintrator' | translate"
      />
    </mat-form-field>

    <!-- Role -->
    <mat-form-field appearance="outline" style="width: 300px">
      <mat-label>
        {{ "view_value.access_permissions" | translate }}
      </mat-label>
      <mat-select formControlName="role">
           <mat-option value="all">
          {{ "view_value.all" | translate }}
        </mat-option>
        <mat-option *ngFor="let item of roleOptions" [value]="item">
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Status -->
    <mat-form-field appearance="outline" style="width: 300px">
      <mat-label> {{ "view_value.status" | translate }} </mat-label>
      <mat-select formControlName="status">
        <mat-option value="all">
          {{ "view_value.all" | translate }}
        </mat-option>
        <mat-option *ngFor="let item of statusOptions" [value]="item.value">
          {{ item.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Actions -->
    <div class="actions">
      <button
        mat-stroked-button
        class="btn-outline"
        type="button"
        (click)="onReset()"
      >
        <mat-icon>history</mat-icon>
        {{ "view_value.reset" | translate }}
      </button>

      <button mat-stroked-button class="btn-primary" type="submit">
        <mat-icon>search</mat-icon>
        {{ "view_value.search" | translate }}
      </button>
    </div>
  </form>

  <!-- Create User -->
  <button
    mat-stroked-button
    class="btn-primary"
    type="button"
    (click)="onCreateUser()"
  >
    <mat-icon>add</mat-icon>
    {{ "view_value.add_admin" | translate }}
  </button>
</div>
